<template>
    <a class="shop-product" :href="`/${product.uri}`">
        <div class="relative">
            <img
                class="shop-product__image lazyload"
                :data-srcset="defaultImage.srcset"
                :data-src="defaultImage.thumb"
                :src="placeholder"
                :alt="product.title"
            >

            <div v-if="!isAvailable" class="shop-product__sold-out">Sold Out</div>
        </div>

        <div class="flex justify-between mt-4">
            <p class="text-sm font-bold text-secondary-500 mr-8">{{ title }}</p>
            <p class="text-sm font-bold text-black whitespace-nowrap">
                <span v-if="priceVaries">from</span>

                <span v-if="minSalePrice !== minPrice" class="line-through text-secondary-500">
                    <MoneyFormat :amount="minSalePrice" />
                </span>

                <span :class="{ 'text-primary-500': minSalePrice !== minPrice }">
                    <MoneyFormat :amount="minPrice" />
                </span>
            </p>
        </div>
    </a>
</template>

<script>
import { svgPlaceholder } from '../utils/svg';
import { isTouchDevice } from '../utils/touch';
import MoneyFormat from './MoneyFormat.vue';

export default {

    components: {
        MoneyFormat,
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            placeholder: svgPlaceholder(1, 1),
            isDirty: false,
            isActive: false,
        };
    },

    computed: {
        title() {
            let title = '';
            if (this.product.vendor.length > 0) {
                title = `${this.product.vendor[0].title} — `;
            }

            title += this.product.title;

            return title;
        },
        priceVaries() {
            const [{ salePrice }] = this.product.variants;
            for (const variant of this.product.variants) {
                if (variant.salePrice !== salePrice) {
                    return true;
                }
            }

            return false;
        },
        minSalePrice() {
            let [{ salePrice }] = this.product.variants;
            for (const variant of this.product.variants) {
                if (variant.salePrice < salePrice) {
                    ({ salePrice } = variant);
                }
            }

            return salePrice;
        },
        minPrice() {
            let [{ price }] = this.product.variants;
            for (const variant of this.product.variants) {
                if (variant.price < price) {
                    ({ price } = variant);
                }
            }

            return price;
        },
        defaultImage() {
            const { images } = this.product;

            if (images.length === 0) {
                return null;
            }

            return images[0];
        },
        isAvailable() {
            for (const variant of this.product.variants) {
                if (variant.isAvailable) {
                    return true;
                }
            }

            return false;
        },
        isTouchDevice() {
            return isTouchDevice();
        },
    },

    methods: {
        onMouseEnter() {
            this.isDirty = true;
            this.isActive = true;
        },
        onMouseLeave() {
            this.isActive = false;
        },
    },
};
</script>
